import { 
  ADD_CHARACTERS, 
  ADD_CHARACTER_LIST , 
  DEL_CHARACTERS , 
  NEXT_PAGE, 
  PREVIOUS_PAGE, 
  RESET_PAGE} 
from './action-types'

export const add = (newCharacter) => ({
  type: ADD_CHARACTERS,
  newCharacter
})

export const del = (newCharacter) => ({
  type: DEL_CHARACTERS,
  newCharacter
})

export const addCaracterList = (response) => ({
  type: ADD_CHARACTER_LIST,
  response
})

export const previous = () => ({
  type: PREVIOUS_PAGE,
})

export const next = () => ({
  type: NEXT_PAGE,
})

export const resetPage = (initialPage) => ({
  type: RESET_PAGE,
  initialPage
})

